import {
  IonContent,
  IonHeader,
  IonItem,
  IonLabel,
  IonMenu,
  IonTitle,
  IonToolbar,
  MenuController,
  ModalController,
} from '@ionic/angular/standalone';

import { Component, HostListener, OnInit, input, inject } from '@angular/core';
import { ChooseEnvironmentComponent } from '../../choose-environment/choose-environment.component';
import { Capacitor } from '@capacitor/core';
import { environment } from '../../../../environments/environment';
import { UtilityBarLoginComponent } from '../../navigation/utility-bar-login/utility-bar-login.component';
import { HelpMenuComponent } from '../../menus/help-menu/help-menu.component';


@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'menu-client-support-login',
  templateUrl: './client-support-login.component.html',
  styleUrls: ['./client-support-login.component.scss'],
  imports: [
    HelpMenuComponent,
    IonContent,
    IonHeader,
    IonItem,
    IonLabel,
    IonMenu,
    IonTitle,
    IonToolbar,
    UtilityBarLoginComponent
],
})
export class ClientSupportLoginComponent implements OnInit {
  private menuCtrl = inject(MenuController);
  private modalCtrl = inject(ModalController);

  readonly isLoggedIn = input<boolean>();

  isDesktop: boolean = true;
  menuSide: string = 'end';
  isNative = Capacitor.isNativePlatform();
  public isDevMode = !environment.production;

  constructor() {
    this.checkScreenSize();
    this.menuSide = this.isDesktop ? 'start' : 'end';
  }

  dismiss() {
    this.menuCtrl.close();
  }

  checkScreenSize() {
    this.isDesktop = window.innerWidth >= 768;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
    this.menuSide = this.isDesktop ? 'start' : 'end';
  }

  ngOnInit() {}

  public async chooseEnvironment() {
    const chooseEnvModal = await this.modalCtrl.create({
      component: ChooseEnvironmentComponent,
    });
    chooseEnvModal.present();
  }
}
